<template>
  <div class="sealed-envelopes">
    <v-container>
      <v-row>
        <v-col cols="6">
          <v-card class="pa-4">
            <v-data-table
              :headers="tableHeader"
              :items="envelopes"
              hide-default-footer
              disable-pagination
              sort-by="ID"
            >
              <template v-slot:item.info="{ item }">
                <v-tooltip
                  bottom
                  v-if="'adminUserID' in item || 'timestamp' in item"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on"
                      ><v-icon>mdi-information</v-icon></v-btn
                    >
                  </template>
                  <span>
                    <p v-if="'timestamp' in item">
                      {{ item.timestamp | moment("YYYY/MM/DD HH:mm") }}
                    </p>
                    <p v-if="'adminUserID' in item">
                      Opened by:
                      <b>{{ dbAdminUsers[item.adminUserID].name }}</b>
                    </p>
                  </span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-row>
            <v-col>
              <v-card class="pa-4">
                <h2 class="text-left">Please make your selection</h2>
                <v-radio-group v-model="group">
                  <v-radio label="Regular sensor user." value="A"></v-radio>
                  <v-radio
                    label="New or naive sensor user."
                    value="B"
                  ></v-radio>
                </v-radio-group>

                <v-btn
                  color="primary"
                  @click="updateGroup()"
                  :disabled="step !== 0 || group === null"
                  >Confirm</v-btn
                >
              </v-card>
            </v-col>
          </v-row>
          <v-row v-if="step === 1">
            <v-col>
              <v-card class="pa-4">
                <h2 class="text-left">
                  The new participant {{ getGroupText() }}.
                </h2>
                <v-divider class="ma-6" />
                <h4 class="text-left">
                  Are you sure that you want to open the sealed envelope?
                </h4>
                <v-card-actions>
                  <v-btn color="primary" @click="openSealedEnvelop()"
                    >YES</v-btn
                  >
                  <v-btn color="secondary" @click="refreshPage()">NO</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="envelopeDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Opened Envelop</v-card-title>
        <v-card-text v-if="openedEnvelop">
          ID: <b>{{ openedEnvelop.ID }}</b
          ><br />
          Intervention: <b>{{ openedEnvelop.arm }}</b
          ><br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="refreshPage()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.sealed-envelopes {
  text-align: center;
}
.sealed-envelopes .md-card {
  width: 100%;
  max-width: 600px;
  display: inline-block;
  vertical-align: top;
  margin: 5px 0px;
  text-align: left;
}
</style>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../firebaseConfig.js");

export default {
  name: "sealed-envelopes",
  computed: {
    ...mapState(["adminUser", "dbAdminUsers"]),
    envelopes: function() {
      if (this.randomization) {
        let openedEnvelopes = [];

        for (let group in this.randomization) {
          for (let par in this.randomization[group]) {
            const sealedEnvelop = this.randomization[group][par];
            if (sealedEnvelop.ID) {
              openedEnvelopes.push({
                ...sealedEnvelop,
                sensor: group === "A" ? "Yes" : "No"
              });
            }
          }
        }

        return openedEnvelopes;
      } else {
        return [];
      }
    },
    nextExp: function() {
      if (this.envelopes.length > 0) {
        return 100 + this.envelopes.filter(env => env.arm === "EXP").length;
      } else {
        return 100;
      }
    },
    nextCTR: function() {
      if (this.envelopes.length > 0) {
        return 0 + this.envelopes.filter(env => env.arm === "CTR").length;
      } else {
        return 0;
      }
    }
  },
  data() {
    return {
      randomization: null,
      envelopeDialog: false,
      openedEnvelop: null,
      group: null,
      step: 0,
      tableHeader: [
        { text: "ID", value: "ID" },
        { text: "Arm", value: "arm" },
        { text: "Sensor", value: "sensor" },
        { text: "", value: "info", sortable: false }
      ]
    };
  },
  created() {
    fb.db.ref("/SealedEnvelopes").on("value", snap => {
      this.randomization = snap.val();
    });
  },
  beforeDestroy() {
    fb.db.ref("/SealedEnvelopes").off();
  },
  methods: {
    updateGroup() {
      if (this.group !== null) {
        this.step++;
      }
    },
    getGroupText() {
      if (this.group === "A") {
        return "is a regular sensor user";
      } else {
        return "is a new or sensor naive user";
      }
    },
    openSealedEnvelop() {
      if (this.group !== "" && this.openedEnvelop === null) {
        this.step++;

        for (var par in this.randomization[this.group]) {
          if (this.randomization[this.group][par].ID === "") {
            this.tryOpenSealedEnvelop(par);
            break;
          }
        }
      }
    },
    generatePID(baseNb) {
      const nb = baseNb + 1;
      return `P${`00${nb}`.slice(-3)}`;
    },
    tryOpenSealedEnvelop(par) {
      const sealedEnvelop = this.randomization[this.group][par];

      if (sealedEnvelop) {
        const envelopID = this.generatePID(
          sealedEnvelop.arm === "EXP" ? this.nextExp : this.nextCTR
        );
        this.openedEnvelop = {
          arm: sealedEnvelop.arm,
          ID: envelopID
        };

        fb.db
          .ref("/SealedEnvelopes")
          .child(this.group)
          .child(par)
          .update(
            {
              ID: envelopID,
              adminUserID: this.adminUser.id,
              timestamp: moment().toISOString()
            },
            error => {
              if (error) {
                this.$store.dispatch("showSnackbar", "There was an error.");
                this.refreshPage();
              } else {
                this.$store.dispatch(
                  "showSnackbar",
                  "Envelop successfully opened"
                );
                this.envelopeDialog = true;
              }
            }
          );
      }
    },
    refreshPage() {
      this.envelopeDialog = false;
      this.openedEnvelop = null;
      this.group = null;
      this.step = 0;
    }
  }
};
</script>
